/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row } from 'reactstrap'

const SubmitterInfo = ({ item }) => {
  const [submitter, setSubmitter] = useState({
    FName: '',
    LName: '',
    conEmail: '',
    conOfficePh: '',
    conCellPh: '',
  })

  const convertFormat = plainPhone => {
    if (
      typeof plainPhone === 'undefined' ||
      plainPhone === '' ||
      plainPhone === null
    )
      return plainPhone
    const phoneDigits = plainPhone.split('')
    if (phoneDigits[0] === '(') return plainPhone
    const formattedPhone =
      '(' +
      phoneDigits[0] +
      phoneDigits[1] +
      phoneDigits[2] +
      ') ' +
      phoneDigits[3] +
      phoneDigits[4] +
      phoneDigits[5] +
      '-' +
      phoneDigits[6] +
      phoneDigits[7] +
      phoneDigits[8] +
      phoneDigits[9]
    return formattedPhone
  }

  useEffect(() => {
    if (item) {
      const { FName, LName, conEmail, conOfficePh, conCellPh } = item
      setSubmitter({
        FName: FName ?? '',
        LName: LName ?? '',
        conEmail: conEmail ?? '',
        conOfficePh: convertFormat(conOfficePh) ?? '',
        conCellPh: convertFormat(conCellPh) ?? '',
      })
    }
  }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>First Name</p>
          <Input name="FName" value={submitter.FName} disabled />
        </FormGroup>
      </Col>
      <Col xs={6}>
        <FormGroup>
          <p>Last Name</p>
          <Input name="LName" value={submitter.LName} disabled />
        </FormGroup>
      </Col>
      <Col xs={4}>
        <FormGroup className={'align-items-center'}>
          <p>Email</p>
          <div className="input-style">
            <a href={'mailto:' + submitter.conEmail}>{submitter.conEmail}</a>
          </div>
        </FormGroup>
      </Col>
      <Col xs={4}>
        <FormGroup>
          <p>Office Phone</p>
          <Input name="conEmail" value={submitter.conOfficePh} disabled />
        </FormGroup>
      </Col>
      <Col xs={4}>
        <FormGroup>
          <p>Cell Phone</p>
          <Input name="conEmail" value={submitter.conCellPh} disabled />
        </FormGroup>
      </Col>
    </Row>
  )
}

export default SubmitterInfo
